import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-youtube-dialog-box',
  templateUrl: './youtube-dialog-box.component.html',
  styleUrls: ['./youtube-dialog-box.component.css']
})
export class YoutubeDialogBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
